import { MaterialConfiguration } from './material-configuration';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
export class ElearningCardConfiguration extends MaterialConfiguration {
    constructor(course: any) {
        super();
        this.tagType = 'eLearning';
        this.thumbnail = course.smallImageUri || 'https://itpx-branded-portal-dev.s3.amazonaws.com/elearning.png';
        this.classType = 'eLearning';
        this.multiContent = course.contents.length > 1;
        this.subtitle = 'branded.portal.courses.assignment.material.elearning.subtitle';
        this.expired = !course.enabled;
        this.clickable = !this.expired;
        this.action = LinkActions.EXPAND;
        this.links = [{
            disabled: this.expired,
            tooltip: this.expired ? 'branded.portal.courses.assignment.material.video.expired.tooltip' : null,
            url: this.expired ? [] : ['scorm', course.contents[0].id],
            text: 'branded.portal.courses.assignment.scorm.player.text',
            type: LinkActions.REDIRECT,
        }]
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/elearning-card-configuration.ts